import { BodyText, Button, Heading, Modal } from '@farol-ds/react'
import { Image } from '@jusbrasil-web/shared-next-image'

import { useValidateOabModalContext } from '../../context'
import erroSvg from '../../images/erro.svg'
import styles from '../steps.module.scss'

export function OabTransferringError() {
  const context = useValidateOabModalContext()
  const { goNextSuccessStep } = context

  return (
    <>
      <Modal.IconClose />
      <Modal.Body className={styles.infoModalBody}>
        <Image src={erroSvg} width={140} height={140} loading="lazy" alt="" />
        <Heading className={styles['infoModalBody-heading']}>Erro ao vincular OAB</Heading>
        <BodyText className={styles['infoModalBody-bodyText']}>
          Por favor, tente novamente ou entre em{' '}
          <a
            href="https://suporte.jusbrasil.com.br/hc/pt-br/requests/new"
            target="_blank"
            rel="noopener noreferrer"
          >
            contato com o suporte.
          </a>
        </BodyText>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={goNextSuccessStep} kind="primary">
          Tentar novamente
        </Button>
      </Modal.Footer>
    </>
  )
}
